export default __webpack_public_path__ + "static/media/logo-white-small.eaeaf999.png";